<div class="fk-tree-view">
  @if (items) {
    @for (item of items; track $index) {
      @if (isGroup(item)) {
        <fk-tree-view-group
          [item]="item"
          [minimized]="minimized"
          [isRootItem]="true"></fk-tree-view-group>
      } @else {
        <fk-tree-view-item
          [item]="item"
          [minimized]="minimized"
          [isRootItem]="true"></fk-tree-view-item>
      }
    }
  } @else {
    <ng-container *ngTemplateOutlet="noDataTemplate"></ng-container>
  }
</div>

<ng-template #noDataTemplate>
  No Data
</ng-template>